import { render } from "./MenuLogo.vue?vue&type=template&id=19686ccc&lang=pug"
import script from "./MenuLogo.vue?vue&type=script&lang=js"
export * from "./MenuLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/menu/MenuLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19686ccc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19686ccc', __exports__)) {
    api.reload('19686ccc', __exports__)
  }
  
  module.hot.accept("./MenuLogo.vue?vue&type=template&id=19686ccc&lang=pug", () => {
    api.rerender('19686ccc', render)
  })

}


export default __exports__